<template>
	<div class="condition-type-indicator" :class="{ 'is-and-condition': DEFAULT_OPERAND === conditionType }">
		<div class="border-indicator"></div>
		<div class="condition-type-text">{{ conditionTypeText }}</div>
	</div>
</template>

<script>
import { MappedTypes, OperandTypes } from '@ply-io/conditions';

export default {
	name: 'ConditionTypeIndicator',
	props: {
		conditionType: { type: String },
	},
	computed: {
		conditionTypeText() {
			return MappedTypes.operands.find((x) => x.value === this.conditionType).text;
		},
	},
	methods: {},
	mounted() {},
	data: () => ({
		DEFAULT_OPERAND: OperandTypes.And,
	}),
};
</script>

<style scoped lang="scss">
.condition-type-indicator {
	$border-radius: 2px;
	@mixin color-mixin($color, $bg-color) {
		color: $color;

		.border-indicator {
			border-color: $color;

			&::before,
			&::after {
				background-color: $color;
			}
		}
		.condition-type-text {
			background-color: $bg-color;
		}
	}

	position: relative;
	font-size: 11px;

	.border-indicator {
		$pad-top: 1px;
		$side-pad: 10px;

		position: relative;
		width: 10px;
		height: calc(100% - (2 * #{$pad-top}));
		margin: $pad-top $side-pad;
		border: 2px solid;
		border-right: 0;
		border-top: 0;
		border-bottom: 0;
		border-radius: 2px;

		&::before,
		&::after {
			content: '';
			position: absolute;
			left: -1px;
			border-radius: 2px;
			height: 2px;
			border: 0;
			width: 6px;
		}

		&::before {
			top: 0;
		}
		&::after {
			bottom: 0;
		}
	}
	.condition-type-text {
		$pad: 2px;

		position: absolute;
		top: 50%;
		left: calc(50% - #{2 * $pad});
		transform: translate(-50%, -50%);
		padding: $pad;
		border-radius: 6px;
	}

	&.is-and-condition {
		@include color-mixin(#5c8df5, #e3ebfd);
	}
	&:not(.is-and-condition) {
		@include color-mixin(#fe902c, #fce7cd);
	}
}
</style>
